import Environment from '@/lib/environment';
import { getAnalyticsToken } from '@/lib/services/auth.service';
import { defineMetabaseAuthConfig, defineMetabaseTheme } from '@surepathai/embedding-sdk-react';

const {
  METABASE_INSTANCE_URL,
  METABASE_INSIGHTS_ENTITY_ID,
  METABASE_USER_GROUP_LG_ENTITY_ID,
  METABASE_USER_GROUP_SMALL_ENTITY_ID,
} = Environment;

export type MBDashboardId = 'insights' | 'userGroupLg' | 'userGroupSmall';

type MBDashboard = {
  id: string;
  isValid: boolean;
};

type MBDashboards = Record<MBDashboardId, MBDashboard>;

const dashboards: MBDashboards = {
  insights: {
    id: METABASE_INSIGHTS_ENTITY_ID,
    isValid: !!METABASE_INSIGHTS_ENTITY_ID,
  },
  userGroupLg: {
    id: METABASE_USER_GROUP_LG_ENTITY_ID,
    isValid: !!METABASE_USER_GROUP_LG_ENTITY_ID,
  },
  userGroupSmall: {
    id: METABASE_USER_GROUP_SMALL_ENTITY_ID,
    isValid: !!METABASE_USER_GROUP_SMALL_ENTITY_ID,
  },
};

const useMetabase = () => {
  const authConfig = defineMetabaseAuthConfig({
    metabaseInstanceUrl: METABASE_INSTANCE_URL,
    fetchRequestToken: getAnalyticsToken,
    preferredAuthMethod: 'jwt',
  });

  return {
    authConfig,
    theme: defineMetabaseTheme({
      components: {
        popover: {
          // ensure SDK popovers/tooltips/menus appear above our app header/sidebar
          zIndex: 4000,
        },
      },
    }),
    dashboards,
  };
};

export default useMetabase;
